/**
 * Types for the post-invest document navigator (folder tree per portfolio
 * company). Mirrors `backend/app/postinvest/documents_schemas.py`; the
 * document row itself is the shared pre-invest shape.
 */

import type { Document } from '@/features/preinvest/_shared/types'

export interface FolderNode {
  id: string
  name: string
  parent_id: string | null
  document_count: number
  children: FolderNode[]
}

export interface FolderTree {
  preinvest_document_count: number
  folders: FolderNode[]
}

export interface Company {
  deal_id: string
  name: string
}

/** Virtual folder id used only client-side for the read-only pre-invest map. */
export const PREINVEST_FOLDER_ID = '__preinvest__'

/** Custom drag type of a file row (told apart from OS file drags by `dataTransfer.types`). */
export const DOC_MIME = 'application/x-vonk-document'

/** A document row as the post-invest API returns it (pre-invest shape plus uploader and note link). */
export interface PostinvestDocument extends Document {
  note_id: string | null
  created_by_name: string | null
}

export type { Document }
